function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M.649 1.043l31.16 31.33L4.494 11.656c11.7 12.214 21.792 22.956 34.322 34.04 1.657 1.465 4.152 2.968 5.185 3.25 2.96 1.117 6.367.154 8.547-2.14 2.993-3.15 3.665-8.888-1.825-14.102C39.119 21.83 28.26 14.513 16.892 7.763l22.924 23.51zm29.394 25.946c16.38 12.074 17.249 11.159 9.836.638 5.444 3.43 9.903 7.573 10.98 8.596a6.377 6.377 0 01.233 9.015c-2.425 2.554-6.223 2.792-9.014.233-1.148-1.052-8.146-7.131-12.374-11.842 10.49 8.47 13.196 7.31.338-6.64z",
  fillRule: "evenodd",
  fill: "var(--primary-color, #000)"
});

var SvgComet = function SvgComet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Comet.c65193de.svg";
export { ForwardRef as ReactComponent };